import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { isValidElement, cloneElement, Children } from 'react';
import PropTypes from 'prop-types';
import UITabs from 'UIComponents/nav/UITabs';
import { Tabs } from 'foundations-components/transitional/components/Tabs';
import { useLocation } from 'react-router-dom';
import { matchPath } from 'react-router-dom';
import { cloneDefaultProps, clonePropTypes, isLegacyComponent } from './internal/utils';

// TODO: refactor to use TabsProps after deprecating UIComponents part
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A [`Tabs`](https://private.hubteamqa.com/foundations-components-storybook/?path=/docs/transitional-tabs--page)
 * type component with router support.
 */
const UIRouterTabs = props => {
  const {
      children
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const location = useLocation();
  let selected = undefined;
  const tabs = Children.map(children, (element, i) => {
    if (! /*#__PURE__*/isValidElement(element)) {
      return null;
    }
    const tabId = element.props.tabId !== undefined ? element.props.tabId : `${i}`;
    if (!selected) {
      const {
        to,
        exact = false,
        strict = false
      } = element.props;
      const path = typeof to === 'object' ? to.pathname : to;
      if (matchPath(location.pathname, {
        path,
        exact,
        strict
      })) {
        selected = tabId;
      }
    }
    return /*#__PURE__*/cloneElement(element, {
      tabId
    });
  });

  // TODO remove this logic after deprecating props
  const TabsComponent = isLegacyComponent(props, ['style', 'className', 'panelClassName', 'listClassName']) ? UITabs : Tabs;
  return /*#__PURE__*/_jsx(TabsComponent, Object.assign({}, rest, {
    selected: selected,
    children: tabs
  }));
};
const _clonePropTypes = clonePropTypes(UITabs),
  sanitizedUITabsPropTypes = _objectWithoutPropertiesLoose(_clonePropTypes, ["selected"]);

// TODO remove after deprecating UIComponents part
UIRouterTabs.propTypes = Object.assign({}, sanitizedUITabsPropTypes, {
  children: PropTypes.node.isRequired
});

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIRouterTabs.defaultProps = cloneDefaultProps(UITabs);
export default UIRouterTabs;